import { TextFilter } from 'app/form-fields/common/register/filters/text/text-filter';
import { TextFilterComponent } from 'app/form-fields/common/register/filters/text/text-filter.component';
import { FormFieldHeaderColumn } from 'app/form-fields/common/register/form-field-header/form-field-header-column';

export class MultilineLineInputHeaderColumn extends FormFieldHeaderColumn {
  constructor(item) {
    super(item);
    this.filter = new TextFilter(null, TextFilterComponent);
  }
}
